<template>
    <div class="fileInfo">
       <div class="infotit">
           <div style="flex:1"><span></span><span></span>{{$t('dataAnalysis.project')}}：{{wayinfo.projectName}}</div>
           <el-button type="primary" icon="el-icon-arrow-left" @click='goblack'>{{$t('realdetile.return')}}</el-button>
       </div>
       <div>
           <div class="handle-box mt10" style="display:flex;align-items:center">
                <div class="fz14 c6" style="">{{$t('realdetile.airCho')}}：</div>
                <el-input v-model.trim="devNumber" :placeholder="$t('realdetile.pleInputAirCode')" class="handle-input mr10" style="width:160px"></el-input>
                <el-button type="primary" size="small" class="ml10" icon="el-icon-search" @click='searchinfo'>{{$t('realtimeinfo.search')}}</el-button>
                <el-button type="primary" size="small" class=" ml10" icon="el-icon-refresh" @click='result'>{{$t('navbar.reset')}}</el-button>
                <div style="flex:1"></div>
                <el-button type="primary" size="small" class=" ml10" icon="el-icon-folder" style='test-align:end' @click='drexcel'>{{$t('fileInfo.import')}}</el-button>
                <el-button type="primary" size="small" class=" ml10" icon="el-icon-refresh" style='test-align:end' @click='bindtx'>{{$t('fileInfo.boundBoard')}}</el-button>
            </div>
       </div>
       <div>
            <el-table
                :data="tableData"
                style="width: 100%">
                <el-table-column
                    v-for="(item,index) in column"
                    :prop="item.prop"
                    :label="item.label"
                    align="center"
                    :key="index"
                    :width="item.width">
                </el-table-column>
                 <el-table-column :label="$t('realdetile.opera')" width="200" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-edit" @click="editHandle(scope.row)">{{$t('alarmSetting.edit')}}</el-button>
                            <el-button type="text" icon="el-icon-delete" class="red" @click="deleteHandle(scope.row)">{{$t('alarmSetting.delete')}}</el-button>
                        </template>
                    </el-table-column>
            </el-table>
       </div>
         <div class="block">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size="10"
                    layout="total, prev, pager, next"
                    :total="totals">
                </el-pagination>
        </div>
        <div style="margin-bottom:10px">{{$t('fileInfo.totalAirModel')}}</div>
         <div style="margin-bottom:20px">
            <el-radio-group v-model="radio1" @change='changeradio'>
            <el-radio-button :label="$t('dataAnalysis.chart')"></el-radio-button>
            <el-radio-button :label="$t('dataAnalysis.form')"></el-radio-button>
            </el-radio-group>
        </div>
        <div class="echarts" v-show="!isechart">
            <div id="echartinfo"></div>
        </div>
        <div v-show="isechart">
            <el-table
                :data="tableData1"
                style="width: 100%">
                <el-table-column
                    v-for="(item,index) in column1"
                    :prop="item.prop"
                    :label="item.label"
                    :key="index"
                    :width="item.width">
                </el-table-column>

            </el-table>
        </div>
        <Fileinfomodel :fileVisible='fileVisible' :tit='tit' @closefileinfo='closefileinfo' ref='fileinfomodel'/>
        <!-- 导入EXCEL表格 -->
    <el-dialog :title="$t('fileInfo.import')" :visible.sync="excelDialogVisible" width='40%' center>
      <el-row>
          <el-upload  :on-change="(e=>{handleChange(e)})" drag action=""
        :auto-upload="false"
               ref="upload">
                <i class="el-icon-plus"></i>
              </el-upload>
        <div>
          <el-button size="small" type="primary" @click="UpData" style="margin:25px 0 15px 0">{{$t('fileInfo.downImport')}}</el-button>
          <p class="login-tips">{{$t('fileInfo.explain')}} <span @click="downmb">{{$t('fileInfo.downLoad')}}</span>。
          </p>
        </div>
      </el-row>
    </el-dialog>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import Fileinfomodel from './fileinfomodel'
import { formatRunStatus, formatBinaryStatus } from '@/util/monitorMetrics'

import {downBlob} from '@/util/utils'
import {projectDeviceList, projectgetDeviceModelById,unbindDevice,exportTemplate,importDevice} from '@/api/deviceOverview/file';
export default {
    name: 'fileInfo',
    components: {
        Fileinfomodel
    },
    data() {
        return {
            host:'',
            excelDialogVisible:false,
            currentPage:1,
            totals:0,
            deviceNoInput:'',
            query:{},
            tableData:[],
            tableData1:[],
            column:[
                {prop:'devNumber',label:this.$t('manipulation.airNum')},
                {prop:'devModelName',label:this.$t('manipulation.airModel')},
                {prop:'towerNumber',label:this.$t('realtimeinfo.roomNum')},
                {prop:'stairsNumber',label:this.$t('realtimeinfo.eleNum')},
                {prop:'devCodeDec',label:this.$t('manipulation.deviceAdressNum')},
                {prop:'imei',label:this.$t('manipulation.comBoard')},
                {prop:'onlineFlag1',label:this.$t('manipulation.comStatus')},
                {prop:'workStatus1',label:this.$t('manipulation.workStatus')},
                {prop:'runStatus1',label:this.$t('manipulation.operaMode')},
            ],
            radio1:this.$t('dataAnalysis.chart'),
            isechart:false,
            fileVisible:false,
            tit:"123",
            column1:[
                {prop:'index',label:this.$t('realdetile.serNum')},
                {prop:'devModel',label:this.$t('manipulation.airModel')},
                {prop:'devModelCount',label:this.$t('alarmSetting.number')},
            ],
            wayinfo:"",
            devNumber:'',
            fileinfo:'',
            page:{
                current:1,
                size:10
            },

        };
    },
    computed: {
        ...mapGetters(['permissions'])
    },
    created() {

    },
    mounted() {
    //   this.getechart()
    },
    methods: {
        handleChange(e){


          this.fileinfo = e
        },
        handleRemove(){

        },
        exceed(v){

        },
        beforeUpload(){

        },
        handleAvatarSuccess(file){

        },
        downmb(){
            exportTemplate().then(res=>{
               downBlob(res)
            })
        },
        drexcel(){
            this.excelDialogVisible = true
        },
        UpData(){
            let obj = {
                projectId:this.wayinfo.id,
                file:this.fileinfo,
                isCovered:0
            }

            let formData = new FormData();
            formData.append('isCovered', 0);
            formData.append('projectId', this.wayinfo.id);
            formData.append('file', this.fileinfo.raw);
            importDevice(formData).then(res=>{

            })
        },

        result(){
            this.devNumber = ''
            this.getprojectDeviceList(this.wayinfo)

        },
        searchinfo(){
            this.getprojectDeviceList(this.wayinfo)
        },
        bindtx(){
            this.tit = this.$t('fileInfo.boundBoard')
            this.$refs.fileinfomodel.getinfo1(this.wayinfo)
            this.fileVisible = true

        },
        editHandle(info){
            this.tit = this.$t('roleManage.revise')
            this.$refs.fileinfomodel.getinfo(info,this.wayinfo)
            this.fileVisible = true
            this.$refs.fileinfomodel.getblur()
        },
        deleteHandle(info){
            this.$confirm(this.$t('fileManage.infoback')+'?', this.$t('alarmSetting.prompt'), {
                confirmButtonText: this.$t('manipulation.sure'),
                cancelButtonText: this.$t('manipulation.cancel'),
            type: 'warning'
            }).then(() => {
                unbindDevice({deviceId:info.id}).then(res=>{
                    if(res.data.code===200){
                        this.$message.success(res.data.msg)
                        this.page.current = 1
                        this.getprojectDeviceList(this.wayinfo)
                    }
                })
            }).catch(() => {});

        },
        closefileinfo(num){
            this.fileVisible = false
            if(num==='0'){
                this.getprojectDeviceList(this.wayinfo)
            }
        },
       changeradio(val){
           if(val===this.$t('dataAnalysis.chart')){
               this.isechart = false
           }else{
               this.isechart = true
           }
       },
       //返回
       goblack(){
           this.$emit('goblack')
       },
       // 获取详情
       getprojectDeviceList(info){
           this.wayinfo = JSON.parse(JSON.stringify(info))
           projectDeviceList({id:info.id,devNumber:this.devNumber,type:'projectDetail',...this.page}).then(res=>{
               if(res.data.code===200){

                   res.data.data.records.map((item,index)=>{
                       item.index = index +1
                       item.workStatus1 = formatBinaryStatus(item.workStatus, {
                           zero: this.$t('realtimeinfo.turnOff'),
                           one: this.$t('realtimeinfo.powerOn'),
                           unreported: this.$t('manipulation.unreported')
                       })
                       item.runStatus1 = formatRunStatus(item.runStatus, {
                           manual: this.$t('manipulation.manual'),
                           timing: this.$t('manipulation.timing'),
                           unreported: this.$t('manipulation.unreported')
                       })
                       item.onlineFlag1 = formatBinaryStatus(item.onlineFlag, {
                           zero: this.$t('realtimeinfo.offLine'),
                           one: this.$t('realtimeinfo.onLine'),
                           unreported: this.$t('manipulation.unreported')
                       })
                   })
                   this.currentPage = res.data.data.current
                   this.totals = res.data.data.total

                   this.tableData = res.data.data.records
               }
           })
           projectgetDeviceModelById({id:info.id}).then(res=>{
               if(res.data.code===200){

                    let xarr = []
                    let yarr = []
                    res.data.data.map((item,index)=>{
                        item.index = index +1
                        xarr.push(item.devModel)
                        yarr.push(item.devModelCount)
                    })
                    this.getechart(xarr,yarr)
                    this.tableData1 = res.data.data
               }
           })
       },
       handleCurrentChange(val){
           this.page.current = val
           this.getprojectDeviceList(this.wayinfo)

       },
       getechart(xarr,yarr){
            let options = {
            title: {
                subtext: '',
            },
            color:'#6395f9',
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                data:xarr
            },
            yAxis: {
                type: 'value',


            },
            series: [

                {
                    name: '',
                    type: 'line',
                    barWidth:20,
                    data: yarr
                }
            ]
        };

          this.drawBarChart('echartinfo', options)

       },
       drawBarChart(id, options) {
            console.log(options, 'optionss-')
            let myChart = echarts.init(document.getElementById(id));
            // 使用 aidState做填充，fakeState显示小线条
            myChart.showLoading({
                text: this.$t('alarmData.loading')+'...'
            });
            myChart.hideLoading();
            myChart.setOption(options, (window.onresize = myChart.resize));
        },
    }
};
</script>

<style lang="scss" scoped>
.fileInfo{
  overflow-y: auto;
  box-sizing: border-box;
  width: calc(100% - 20px);
  .handle-box{
      margin-bottom: 20px;
  }
  .infotit{
      display: flex;
      align-items: center;
      border-bottom:3px solid #01ADA8;
      padding-bottom: 2px;
  }
  .block{
      text-align: end;
      margin-top: 10px;
  }
  .echarts{
      width:100%;
      height: 300px;
      #echartinfo{
          width:100%;
          height: 100%;
      }
  }
}

</style>
